
import { useState, useEffect } from 'react';
import ServicesNavbar from './components/ServicesNavbar';
import ServicesHero from './components/ServicesHero';
import ServiceDetails from './components/ServiceDetails';
import PricingPackages from './components/PricingPackages';
import AddOns from './components/AddOns';
import ProcessSection from './components/ProcessSection';
import ConsultationForm from './components/ConsultationForm';
import ServicesFooter from './components/ServicesFooter';

export default function ServicesPage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <ServicesNavbar scrolled={scrolled} />
      <ServicesHero />
      <ServiceDetails />
      <PricingPackages />
      <AddOns />
      <ProcessSection />
      <ConsultationForm />
      <ServicesFooter />
    </div>
  );
}
